import {AtributoEspecime, Destino, FormaRegistro, Grupo, SituacaoEspecime} from "../../../../domain/enums";
import {ActivatedRoute} from "@angular/router";
import {Especime} from "../../../../domain/Especime";

export class ControleExbicao {

  route!: ActivatedRoute
  atributos: AtributoEspecime[]
  especime?: Especime


  exibir(nomeCampo: AtributoEspecime, especime: Especime|undefined): boolean {
    this.especime = especime
    const grupo = especime.taxon?.grupo
    const metodos = especime?.monitoramento?.metodos
    const metodo = metodos?.find(m=> m.grupos.includes(grupo) )
    this.atributos = metodo?.listaAtributosEspecime
    // const keys = this.atributos?.map(a=> Object.keys(AtributoEspecime)[Object.values(AtributoEspecime).indexOf(a)])
    // console.log('taxon', this._entidade?.taxon)
    // console.log('monitoramento', this._entidade?.monitoramento)
    return this.atributos?.find(a => a == nomeCampo) != undefined && this.dinamicos(nomeCampo)
  }

  dinamicos(nomeCampo: AtributoEspecime): boolean {
    // const keys = Object.keys(AtributoEspecime)
    // console.log('keys', keys)
    // const values = Object.values(AtributoEspecime)
    // console.log('values', values)
    //
    // const att = nomeCampo as AtributoEspecime
    // console.log('att', att)
    // const index = keys[values.indexOf(att)]
    // console.log('index', index)
    // const atributo = Object.keys(AtributoEspecime)[Object.values(AtributoEspecime).indexOf(nomeCampo as AtributoEspecime)]
    // console.log('atributo', atributo)
    switch (nomeCampo) {
      case AtributoEspecime.meteorologias : return this.hpf
      case AtributoEspecime.comprimentoTotal : return (this.avf || this.icf) && this.capRecap
      case AtributoEspecime.comprimentoCabeca : return (this.avf || this.mtf) && this.capRecap
      case AtributoEspecime.comprimentoCauda : return (this.avf || this.mtf) && this.capRecap
      case AtributoEspecime.comprimentoAsa : return this.avf && this.capRecap
      case AtributoEspecime.comprimentoTarso : return this.avf && this.capRecap
      case AtributoEspecime.diametroTarso : return this.avf && this.capRecap
      case AtributoEspecime.pesoCorporal : return (this.avf || this.hpf || this.mtf || this.icf|| this.qpf) && this.capRecap
      case AtributoEspecime.comprimentoBico : return this.avf  && this.capRecap
      case AtributoEspecime.larguraBico : return this.avf  && this.capRecap
      case AtributoEspecime.alturaBico : return this.avf  && this.capRecap
      case AtributoEspecime.gorduraSubcutanea : return this.avf  && this.capRecap
      case AtributoEspecime.placaIncubacao : return this.avf  && this.capRecap
      case AtributoEspecime.mudaPenas : return this.avf  && this.capRecap
      case AtributoEspecime.destino : return (this.avf || this.hpf || this.mtf || this.icf|| this.qpf) && this.capRecap
      case AtributoEspecime.instituicaoDepositaria : return (this.avf || this.hpf || this.mtf || this.icf|| this.qpf) && this.capRecap && this.isDeposito
      case AtributoEspecime.numeroTombamento : return (this.avf || this.hpf || this.mtf || this.icf|| this.qpf) && this.capRecap && this.isDeposito
      case AtributoEspecime.areaSoltura : return (this.avf || this.hpf || this.mtf || this.icf|| this.qpf) && this.capRecap && this.isSoltura
      case AtributoEspecime.dataHoraSoltura : return (this.avf || this.hpf || this.mtf || this.icf|| this.qpf) && this.capRecap && (this.isSoltura || this.isDeposito)
      case AtributoEspecime.tipoMarcacao : return (this.avf || this.hpf || this.mtf || this.icf|| this.qpf) && this.capRecap
      case AtributoEspecime.numeroMarcacao : return (this.avf || this.hpf || this.mtf || this.icf|| this.qpf) && this.capRecap
      case AtributoEspecime.temperaturaAr : return this.etf  && this.capRecap
      case AtributoEspecime.comprimentoRostroCloacal : return this.hpf  && this.capRecap
      case AtributoEspecime.comprimentoPadrao : return this.avf  && this.capRecap
      case AtributoEspecime.estagioMaturacaoGonadal : return this.icf  && this.capRecap
      case AtributoEspecime.comprimentoCorpo : return (this.mtf || this.qpf)  && this.capRecap
      case AtributoEspecime.comprimentoPataTraseira : return this.mtf  && this.capRecap
      case AtributoEspecime.larguraCabeca : return this.mtf  && this.capRecap
      case AtributoEspecime.comprimentoTronco : return this.mtf  && this.capRecap
      case AtributoEspecime.alturaCinturaPelvica : return this.mtf  && this.capRecap
      case AtributoEspecime.larguraCinturaPelvica : return this.mtf  && this.capRecap
      case AtributoEspecime.circunferenciaTorax : return this.mtf  && this.capRecap
      case AtributoEspecime.circunferenciaCabeca : return this.mtf  && this.capRecap
      case AtributoEspecime.circunferenciaPescoco : return this.mtf  && this.capRecap
      case AtributoEspecime.comprimentoOrelha : return (this.mtf || this.qpf)  && this.capRecap
      case AtributoEspecime.distanciaInterOlhos : return this.mtf  && this.capRecap
      case AtributoEspecime.larguraMandibula : return this.mtf  && this.capRecap
      case AtributoEspecime.prenha : return (this.mtf || this.qpf)  && this.capRecap
      case AtributoEspecime.lactando : return (this.mtf || this.qpf)  && this.capRecap
      case AtributoEspecime.numeroFilhotes : return this.mtf   && this.capRecap
      case AtributoEspecime.glandulasMamarias : return (this.mtf || this.qpf)  && this.capRecap
      case AtributoEspecime.aberturaVaginal : return this.mtf   && this.capRecap
      case AtributoEspecime.escrotado :  return (this.mtf || this.qpf)  && this.capRecap
      case AtributoEspecime.comprimentoPe :  return this.qpf   && this.capRecap
      case AtributoEspecime.comprimentoAnteBraco :  return this.qpf  && this.capRecap

      default: return true
    }
  }

  get dashboard(): boolean {return this.route.snapshot.paramMap.get('dashboard')!! == 'true'}
  get grupo(): Grupo { return this.especime.taxon?.grupo!! }
  get avf(): boolean {return this.grupo == Grupo.AVF }
  get mtf(): boolean { return this.grupo == Grupo.MTF }
  get hpf(): boolean { return this.grupo == Grupo.HPF }
  get icf(): boolean { return this.grupo == Grupo.ICF }
  get etf(): boolean { return this.grupo == Grupo.ETF }
  get qpf(): boolean { return this.grupo == Grupo.QPF}
  get capRecap(): boolean | undefined {
    return this.especime.formasRegistro?.find((f: any) => f == FormaRegistro.CAPTURA || f == FormaRegistro.RECAPTURA) != undefined
  }
  get isSoltura(): boolean { return this.especime?.destino == Destino.SOLTURA }
  get isDeposito(): boolean { return this.especime?.destino == Destino.DEPOSITO }
  get isMorto(): boolean { return this.especime?.estado == SituacaoEspecime.MORTO }

}
